const convertNumberToPersianExactUnits = (input: number | string): string => {
  let number = Number(input);

  if (isNaN(number) || number <= 0) return '0 تومان';

  const parts: string[] = [];

  const billions = Math.floor(number / 1_000_000_000);
  number %= 1_000_000_000;

  const millions = Math.floor(number / 1_000_000);
  number %= 1_000_000;

  const thousands = Math.floor(number / 1_000);
  number %= 1_000;

  const remainder = number;

  if (billions) parts.push(`${billions} میلیارد`);
  if (millions) parts.push(`${millions} میلیون`);
  if (thousands) parts.push(`${thousands} هزار`);
  if (remainder) parts.push(`${remainder} تومان`);
  else parts.push('تومان');

  return parts.join(' و ');
};

export default convertNumberToPersianExactUnits;
